import {
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Stack,
} from "@mui/material";
import {
  STRINGS_CATEGORIES,
  STRINGS_CREATE,
} from "../../../data/strings/Strings";
import {
  COLOR_BLACK,
  COLOR_LESS_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_WHITE,
} from "../../../data/colors/Colors";
import { AddRounded, ReportGmailerrorredOutlined } from "@mui/icons-material";
import { StoresViewModel } from "./StoresViewModel";
import { StoresListItemView } from "./listItemView/StoreListItemView";
import {
  ROUTE_ENDPOINTS,
  ROUTE_NEW,
} from "../../../data/constant/RouteConstants";
import { CustomTextView } from "../../component/CustomTextView";
import { HeaderView } from "../../component/HeaderView";
import { EmptyView } from "../../component/EmptyView";
import { LoadingView } from "../../component/LoadingView";
import {
  provideGetAllStoresUseCase,
  provideGetPerStoreReportUseCase,
} from "../../di/UseCasesModule";

export function StoresView() {
  const viewModel = StoresViewModel(
    provideGetAllStoresUseCase(),
    provideGetPerStoreReportUseCase()
  );
  return (
    <Stack spacing={2}>
      <HeaderView
        title={"Stores"}
        isLayoutFullWidthInSmallerScreens={false}
        layout={
          <Stack direction={"row"} display={"flex"} justifyContent={"end"}>
            <Button
              href={`${ROUTE_ENDPOINTS.HOME_STORES}/${ROUTE_NEW}`}
              LinkComponent={"a"}
              variant="outlined"
              sx={{
                borderRadius: 22,
                borderColor: COLOR_BLACK,
                "&:hover": {
                  borderColor: COLOR_BLACK,
                },
              }}
            >
              <AddRounded fontSize="medium" sx={{ color: COLOR_BLACK }} />
              <CustomTextView
                text={STRINGS_CREATE}
                fontWeight="bold"
                fontSize={16}
                props={{ textTransform: "none" }}
                textColor={COLOR_BLACK}
              />
            </Button>
          </Stack>
        }
      />
      <Container maxWidth={false}>
        <>
          {viewModel.isLoading ? (
            <LoadingView />
          ) : (
            <>
              {viewModel.stores && (
                <>
                  {viewModel.stores.length === 0 ? (
                    <EmptyView />
                  ) : (
                    <Grid container spacing={1.5} pb={3}>
                      {viewModel.stores.map((store, index) => {
                        return (
                          <Grid
                            size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 4 }}
                            key={store._id}
                          >
                            <StoresListItemView
                              store={store}
                              index={index}
                              href={`${ROUTE_ENDPOINTS.HOME_STORES}/${store._id}`}
                            />
                          </Grid>
                        );
                      })}
                    </Grid>
                  )}
                </>
              )}
            </>
          )}
        </>
      </Container>
    </Stack>
  );
}
